"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5870],{

/***/ 98397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ setReactGA; },
/* harmony export */   "Z": function() { return /* binding */ getReactGA; }
/* harmony export */ });
var ReactGA = null;
var setReactGA = function(reactGA) {
    ReactGA = reactGA;
};
var getReactGA = function() {
    return ReactGA;
};


/***/ }),

/***/ 14726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trackPageView; }
/* harmony export */ });
/* harmony import */ var _helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98397);
/* harmony import */ var _helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55985);
/* harmony import */ var ga_4_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13241);



function trackPageView(pathname) {
    var pixel = (0,_helpers_getReactPixel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    if (!pathname.includes("/virtual")) {
        pixel === null || pixel === void 0 ? void 0 : pixel.pageView();
    }
    var ReactGA = (0,_helpers_getReactGA__WEBPACK_IMPORTED_MODULE_2__/* .getReactGA */ .Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(pathname);
    if (ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isInitialized */ .ZP.isInitialized()) {
        var ga4 = ga_4_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGA4React */ .ZP.getGA4React();
        if (ga4) {
            ga4.pageview(pathname);
        }
    }
};


/***/ }),

/***/ 55870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ECOMMERCE_EVENTS; },
  "Z": function() { return /* binding */ useTrackEcommerceEvent; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/sendEcommerceEventMutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation sendEcommerceEvent(\n    $eventName: String\n    $eventIdentifier: String\n    $actionSource: String\n    $orderId: ID\n    $currency: String\n    $items: [JSON]\n    $totalPrice: Float\n    $origin: String\n  ) {\n    sendEcommerceEvent(\n      eventName: $eventName\n      eventIdentifier: $eventIdentifier\n      actionSource: $actionSource\n      orderId: $orderId\n      currency: $currency\n      items: $items\n      totalPrice: $totalPrice\n      origin: $origin\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var sendEcommerceEventMutation = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/helpers/getReactGA.ts
var getReactGA = __webpack_require__(98397);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/helpers/getReactPixel.ts
var getReactPixel = __webpack_require__(55985);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/ga-4-react/dist/ga-4-react.esm.js
var ga_4_react_esm = __webpack_require__(13241);
;// CONCATENATED MODULE: ./src/helpers/track/eventAnalytics/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var providers = {
    GA4: "ga4",
    PIXEL: "pixel",
    GTM: "gtm"
};
var pixelSendEvent = function(eventName, data, eventExtraData) {
    var reactPixel = (0,getReactPixel/* default */.Z)();
    reactPixel === null || reactPixel === void 0 ? void 0 : reactPixel.fbq("track", eventName, data, eventExtraData);
};
var recommendedEvents = {
    ADD_TO_CART: {
        pixel: "AddToCart",
        ga4: "add_to_cart",
        gtm: "add_to_cart"
    },
    BEGIN_CHECKOUT: {
        pixel: "InitiateCheckout",
        ga4: "begin_checkout",
        gtm: "begin_checkout"
    },
    PURCHASE: {
        pixel: "Purchase",
        ga4: "purchase",
        gtm: "purchase"
    },
    SELECT_ITEM: {
        ga4: "select_item",
        gtm: "select_item"
    }
};
var ga4SendEvent = function(action, additionalData) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, label = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, category = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, nonInteraction = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if ((0,isServerSide/* default */.Z)()) return;
    var isInitialized = ga_4_react_esm/* default.isInitialized */.ZP.isInitialized();
    if (!isInitialized) {
        return;
    }
    var ga4 = ga_4_react_esm/* default.getGA4React */.ZP.getGA4React();
    if (!ga4) {
        logger/* default.warn */.Z.warn("Could not get GA4React");
        return;
    }
    var data = _objectSpread({}, additionalData);
    if (custom) {
        data = _objectSpread({}, data, {
            event_label: label,
            event_category: category,
            nonInteraction: nonInteraction
        });
    }
    ga4.gtag("event", action, data);
};
var gtmSendEvent = function(dataLayer) {
    dist_default().dataLayer({
        dataLayer: dataLayer
    });
};
var analyticsEventManager = {
    pixel: pixelSendEvent,
    ga4: ga4SendEvent,
    gtm: gtmSendEvent
};

// EXTERNAL MODULE: ./src/helpers/track/trackPageView.ts
var trackPageView = __webpack_require__(14726);
;// CONCATENATED MODULE: ./src/helpers/track/trackAddToCart.ts




function trackAddToCart(param, param1) {
    var product = param.product, item = param.item, amount = param.amount, eventId = param1.eventId;
    if (!product || !item) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    var currency = (0,getCurrencyCode/* default */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
        id: product._id,
        name: product.name,
        price: item.unitPrice,
        category: product.categories.length ? product.categories[0].internalName : null,
        quantity: amount,
        currency: currency
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "add");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.event({
        category: "UX",
        action: "addProductToCart",
        label: "Agregar al carro"
    });
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id,
        value: item.unitPrice,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.ADD_TO_CART.pixel, pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: item.unitPrice,
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                price: item.unitPrice,
                quantity: amount
            }
        ]
    };
    analyticga4SendEvent(recommendedEvents.ADD_TO_CART.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.ADD_TO_CART.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name,
                    price: item.unitPrice,
                    quantity: amount
                }
            ]
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/add_to_cart");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackInitCheckout.ts



function trackInitCheckout(param, param1) {
    var cart = param.cart, eventId = param1.eventId;
    if (!cart) return;
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "checkout");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview("/checkout");
    var currency = (0,getCurrencyCode/* default */.Z)();
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var numItems = cart.items.reduce(function(sum, item) {
        return item.amount + sum;
    }, 0);
    var pixelData = {
        value: cart.itemsPrice,
        num_items: numItems,
        currency: currency
    };
    analyticPixelSendEvent(recommendedEvents.BEGIN_CHECKOUT.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(cart.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        value: cart.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.BEGIN_CHECKOUT.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.BEGIN_CHECKOUT.gtm,
        ecommerce: {
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
};

;// CONCATENATED MODULE: ./src/helpers/track/trackProductView.ts
function trackProductView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function trackProductView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            trackProductView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function trackProductView(param, param1) {
    var product = param.product, eventId = param1.eventId;
    if (!product) return;
    if (!product.availabilityAt) return;
    var finalPrice = product.availabilityAt.finalPrice;
    var currencyCode = (0,getCurrencyCode/* default */.Z)();
    var gaData = {
        id: product._id,
        name: product.name,
        category: product.categories.length ? product.categories[0].internalName : null
    };
    var ga4Data = {
        items: [
            {
                item_id: product._id,
                item_name: product.name,
                category: product.categories.length ? product.categories[0].internalName : null,
                currency: currencyCode
            }
        ]
    };
    var pixelData = {
        content_name: product.name,
        content_type: "product",
        content_ids: product._id
    };
    var gtmData = {
        event: recommendedEvents.SELECT_ITEM.gtm,
        ecommerce: {
            items: [
                {
                    item_id: product._id,
                    item_name: product.name
                }
            ]
        }
    };
    if (finalPrice) {
        pixelData = trackProductView_objectSpread({}, pixelData, {
            value: finalPrice,
            currency: currencyCode
        });
        ga4Data["items"] = [
            trackProductView_objectSpread({}, ga4Data["items"][0], {
                price: finalPrice
            })
        ];
        gtmData["ecommerce"]["items"] = [
            trackProductView_objectSpread({}, gtmData["ecommerce"]["items"][0], {
                price: finalPrice
            })
        ];
        gaData = trackProductView_objectSpread({}, gaData, {
            price: finalPrice
        });
    }
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currencyCode
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addImpression", gaData);
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "detail");
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    analyticPixelSendEvent("ViewContent", pixelData, {
        eventID: eventId
    });
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    analyticga4SendEvent(recommendedEvents.SELECT_ITEM.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/view_content");
};

;// CONCATENATED MODULE: ./src/helpers/track/trackPurchase.ts




function trackPurchase(param, param1) {
    var order = param.order, eventId = param1.eventId;
    if (!order) return;
    var currency = (0,getCurrencyCode/* default */.Z)();
    var ReactGA = (0,getReactGA/* getReactGA */.Z)();
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "clear", {});
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.set({
        currencyCode: currency
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = order.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "addProduct", {
                id: item.product._id,
                name: item.product.name,
                category: item.product.categories.length ? item.product.categories[0].internalName : null,
                price: item.unitPrice,
                quantity: item.amount
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.plugin.execute("ec", "setAction", "purchase", {
        id: order._id,
        revenue: order.totalPrice,
        coupon: order.couponCode,
        shipping: order.deliveryFee
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : ReactGA.pageview(window.location.pathname);
    var analyticPixelSendEvent = analyticsEventManager[providers.PIXEL];
    var pixelData = {
        value: order.totalPrice,
        num_items: order.totalItems,
        currency: currency,
        content_type: "product",
        content_ids: Array.from(order.items.map(function(item) {
            return item.product._id;
        }))
    };
    analyticPixelSendEvent(recommendedEvents.PURCHASE.pixel, pixelData, {
        eventID: eventId
    });
    var items = Array.from(order.items.map(function(item) {
        return {
            item_id: item.product._id,
            item_name: item.product.name,
            item_category: item.product.categories.length ? item.product.categories[0].internalName : null,
            price: item.unitPrice,
            quantity: item.amount
        };
    }));
    var analyticga4SendEvent = analyticsEventManager[providers.GA4];
    var ga4Data = {
        currency: currency,
        transaction_id: order._id,
        value: order.totalPrice,
        items: items
    };
    analyticga4SendEvent(recommendedEvents.PURCHASE.ga4, ga4Data);
    var analyticsgtmSendEvent = analyticsEventManager[providers.GTM];
    var gtmData = {
        event: recommendedEvents.PURCHASE.gtm,
        ecommerce: {
            currency: currency,
            transaction_id: order._id,
            value: order.totalPrice,
            items: items
        }
    };
    analyticsgtmSendEvent(gtmData);
    (0,trackPageView/* default */.Z)("/virtual/purchase");
};

;// CONCATENATED MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useTrackEcommerceEvent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useTrackEcommerceEvent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useTrackEcommerceEvent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var ECOMMERCE_EVENTS;
(function(ECOMMERCE_EVENTS) {
    ECOMMERCE_EVENTS["PAGEVIEW"] = "PageView";
    ECOMMERCE_EVENTS["VIEWCONTENT"] = "ViewContent";
    ECOMMERCE_EVENTS["INITCHECKOUT"] = "InitiateCheckout";
    ECOMMERCE_EVENTS["ADDTOCART"] = "AddToCart";
    ECOMMERCE_EVENTS["PURCHASE"] = "Purchase";
})(ECOMMERCE_EVENTS || (ECOMMERCE_EVENTS = {}));
function serverSendEvent(eventName, mutate, data) {
    return _serverSendEvent.apply(this, arguments);
}
function _serverSendEvent() {
    _serverSendEvent = _asyncToGenerator(runtime_default().mark(function _callee(eventName, mutate, data) {
        var orderId, eventId, source, items, currency, totalPrice, variables;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (mutate) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    orderId = data.orderId, eventId = data.eventId, source = data.source, items = data.items, currency = data.currency, totalPrice = data.totalPrice;
                    variables = useTrackEcommerceEvent_objectSpread({
                        eventName: eventName,
                        eventIdentifier: eventId,
                        currency: currency,
                        totalPrice: totalPrice,
                        actionSource: source,
                        origin: "web"
                    }, items && {
                        items: items
                    }, orderId && {
                        orderId: orderId
                    });
                    _ctx.next = 7;
                    return mutate({
                        mutation: sendEcommerceEventMutation,
                        variables: variables
                    });
                case 7:
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    logger/* default.warn */.Z.warn("could not send event to ecommerceEvents", {
                        error: _ctx.t0
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _serverSendEvent.apply(this, arguments);
}
function useTrackEcommerceEvent() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var trackEcommerceEvent = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event1, params1) {
            var getEventServerData, serverData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getEventServerData = function _getEventServerData(event, params) {
                            var eventId = (0,v4/* default */.Z)();
                            var currency = (0,getCurrencyCode/* default */.Z)();
                            var baseData = {
                                currency: currency,
                                eventId: eventId,
                                source: location.origin
                            };
                            if (event === ECOMMERCE_EVENTS.PAGEVIEW) {
                                (0,trackPageView/* default */.Z)(params);
                                return null;
                            }
                            if (event === ECOMMERCE_EVENTS.VIEWCONTENT) {
                                trackProductView(params, {
                                    eventId: eventId
                                });
                                var product = params.product;
                                var items = [
                                    {
                                        id: product._id,
                                        quantity: 1,
                                        itemPrice: product.value,
                                        itemName: product.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items,
                                    totalPrice: product.value
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.INITCHECKOUT) {
                                trackInitCheckout(params, {
                                    eventId: eventId
                                });
                                var cart = params.cart;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: Array.from(cart.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    })),
                                    totalPrice: cart.itemsPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.ADDTOCART) {
                                trackAddToCart(params, {
                                    eventId: eventId
                                });
                                var product1 = params.product, amount = params.amount, item1 = params.item;
                                var items1 = [
                                    {
                                        id: product1._id,
                                        quantity: amount,
                                        itemPrice: item1.unitPrice,
                                        itemName: product1.name
                                    }
                                ];
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    items: items1,
                                    totalPrice: item1.totalPrice
                                });
                            }
                            if (event === ECOMMERCE_EVENTS.PURCHASE) {
                                trackPurchase(params, {
                                    eventId: eventId
                                });
                                var order = params.order;
                                return useTrackEcommerceEvent_objectSpread({}, baseData, {
                                    orderId: order._id,
                                    totalPrice: order.totalPrice
                                }, order.items && {
                                    items: Array.from(order.items.map(function(item) {
                                        return {
                                            id: item.product._id,
                                            quantity: item.amount,
                                            itemPrice: item.unitPrice,
                                            itemName: item.product.name
                                        };
                                    }))
                                });
                            }
                            return null;
                        };
                        _ctx.prev = 1;
                        ;
                        serverData = getEventServerData(event1, params1);
                        if (serverData) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return serverSendEvent(event1, mutate, serverData);
                    case 8:
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        logger/* default.warn */.Z.warn("error useTrackEcommerceEvent", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function trackEcommerceEvent(event1, params1) {
            return _ref.apply(this, arguments);
        };
    }();
    return trackEcommerceEvent;
};


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GetCurrencyCode; }
/* harmony export */ });
/* harmony import */ var _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66767);

function GetCurrencyCode() {
    var locale = __webpack_require__.g.currentLocale || "es_CL";
    return _formatNumber_currencyCodes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[locale];
};


/***/ })

}]);